import React, { useState, useEffect } from 'react';
import { actionsType } from 'config/constants';
import PropTypes from 'prop-types';
import { slugify, cleanSearch, getLinkCategory } from 'utils'
import queryString from 'query-string';
import Loader from "components/Loader";
import BannerShelf from "components/BannerShelf";
import ShelfHeader from 'components/ShelfHeader';
import BreadCrumb from 'components/BreadCrumb';
import Shelf from "containers/Shelf";
import ProductService from "services/Product/";
import FilterService from 'services/Filter/';
import Metas from 'components/Metas';
import CmsService from "services/CMS/";
import PubSub from "services/PubSub/";
import { usePrevious } from 'hooks';
import style from './style.scss';//NOSONAR

let _isMounted = false;
let filterService = null;
let categoriesParams = null;
let categories = [];
let category = null;
let filters = null;
let specifications = [];
let location = null;
let filterByBrand = false;
let actions = [];

const Catalog = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const search = props.location.search;

    const prevAmount = usePrevious(props);

    useEffect(() => {
        if(prevAmount && (prevAmount.location.pathname === "/busca")  && (prevAmount.location.search !== search)) {
            filterService = new FilterService(props);
            categoriesParams = filterService.categories;
            getContent();
        }
    }, [search]);

    useEffect(() => {
        _isMounted = true;
        location = props.location;
        filterService = new FilterService(props);
        categoriesParams = filterService.categories;

        getContent();

        return () => {
            _isMounted = false;
        };
    }, []);

    useEffect(()=> {
        actions.push(PubSub.register('catalog_empty', () => redirectError404()));
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => getContent()));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        const pathname = props.location.pathname;
        const search = props.location.search;
        const prevPathname = location.pathname;
        const prevSearch = location.search;
        const searchParsed = queryString.parse(search);
        const prevSearchParsed = queryString.parse(prevSearch);

        if (pathname !== prevPathname || (prevSearch !== '' && search === '') || (searchParsed.ft && searchParsed.ft !== prevSearchParsed.ft)) {
            filterService = new FilterService(props);
            location = props.location;
            categoriesParams = filterService.categories;

            getContent();
        }

        location = props.location;
    }, [props.location]);

    const getContent = () => {
        if(isLoaded){
            setIsLoaded(false);
        }

        const {pathname, search} = props.location;

        Promise.all([ProductService.getFilters(pathname + validateParams(search)), getcmsCategories()]).then(results => {
            const cmsCats = results[1];
            const resultsFilter = results[0];

            filterByBrand = resultsFilter.filterByBrand;

            const { search } = filterService;

            const vtexCats = resultsFilter && resultsFilter.CategoriesTrees ? resultsFilter.CategoriesTrees : [];

            const categoriesFiltered = _filterCategories(cmsCats, vtexCats, (filterByBrand ? resultsFilter.Brands : []));

            if(!filterByBrand && !resultsFilter.notFound){
                _applyCategories(categoriesFiltered);
            }

            if (search !== '' && !(resultsFilter && resultsFilter.Departments && resultsFilter.Departments[0])) {
                redirectError404(search);
            }

            if(filterByBrand){
                const countPath = pathname.split('/').length - 1;
                if(!(resultsFilter.Brands.length <= countPath)) {
                    redirectError404(search);
                    return false;
                }
            }


            filters = {
                categories: categoriesFiltered,
                brands: resultsFilter.Brands,
                filters: resultsFilter.SpecificationFilters
            };

            if(resultsFilter.notFound){
                redirectError404(search);
            } else {
                init();
            }
        });
    }

    const _applyCategories = (results) => {
        categories = getCategories(0, results);
        categories = categories.map((category) => {
            let link = null;

            if(typeof category !== 'string') {
                link = { ...category };
                link.url = getLinkCategory(link.url);
            }

            return link ? link : category;
        });

        const search = (categoriesParams && categoriesParams.length > 0) ? [...categoriesParams].pop() : "";

        if (categories.length === 0 && filterService.search === '' && filterService.collections === '' && !filterByBrand) {
            redirectError404(search);
        }

        category = categories.slice(-1).pop();
    }

    const getcmsCategories = () => {
        if(!(window && window.location)) return false;
        return CmsService.getMenu(false).then(data => {
            return JSON.parse(JSON.stringify(data.acf.items));
        });
    }

    const _filterCategories = (cmsCats, vtexCats, brands = []) => {
        const categories = cmsCats.map(category => {

            const indexCat = vtexCats.findIndex(cat => {
                return clearURL(cat.Link.split('?')[0].toLowerCase()).indexOf(clearURL(category.url)) !== -1
            });

            if(indexCat !== -1){
                if(category.items){
                    category.items = _filterCategories(category.items, vtexCats[indexCat].Children, brands);
                }

                const brandsPath = brands.length ? '/' + brands.map(item=> slugify(item.Name)).join('/') : '';

                category.id = vtexCats[indexCat].Id;

                if(filterByBrand){
                    category.url = category.url + brandsPath;
                }

                return category

            }else{
                return false
            }

        }).filter(Boolean);

        return fixCategories(categories);
    }

    const validateParams = (search) => {
        if(search){
            let params = queryString.parse(search);

            if(params.ft){
                params.ft = cleanSearch(params.ft);
            }

            search = '?' + queryString.stringify(params);
        }

        return search;
    }

    const getCategories = (index, categories) => {
        let currentCategories = [];
        const categoryName = Array.isArray(categoriesParams) && categoriesParams[index] ? '/' + categoriesParams.slice(0, index + 1).join('/') : '';
        for (let i = 0; i < categories.length; i++) {
            const category = categories[i];
            if (clearURL(category.url.split('?')[0]) === clearURL(categoryName)) {
                currentCategories = currentCategories.concat(category);
                if (categoriesParams[index + 1]) {
                    const children = getCategories(index + 1, category.items);
                    if (children) {
                        currentCategories = currentCategories.concat(children);
                    }
                }
            }
        }
        return (currentCategories.length) ? currentCategories : [];
    }

    const clearURL = (url) => {
        return url.replace('---', '-').replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o").replace(/ú/g, "u").replace(/ñ/g, "n");
    }

    const redirectError404 = (search = null) => {
        search = search ? `?ft=${search}` : '';
        props.history.push(`/Sistema/buscavazia${search}`);
    }

    const fixCategories = (categories) => {
        return categories ? categories.map((category) => {
            const params = window.location.search;
            return {
                id: category.id,
                items: category.items ? fixCategories(category.items) : [],
                name: category.name || category.title,
                url: category.url + params
            }
        }) : [];
    }

    const applyInitialFilters = () => {
        const { brands, specifications } = filterService;
        brands.map((brand) => {
            filters.brands
                .map((item) => item.active = item.active || (slugify(item.Name) === brand));
        });

        specifications.map(specification => {
            specifications.filter((item) => {
                return item.FieldId === parseInt(specification.id)
            }).map(item =>
                filters.filters[item.Name].map((item) =>
                    item.active = item.active || (item.Name === specification.slug)
                )
            );
        });
    }

    const init = () => {
        if (filterService.search === '' && filterService.collections === '') {
            if(category) {
                filters.categories = [category];

                ProductService.getCategorySpecifications(category.id).then(results => {
                    if(typeof category !== 'string'){
                        specifications = results;
                    }
                    initFilters();
                });
            } else if(filterByBrand){
                initFilters();
            }
        } else {
            initFilters();
        }
    }

    const initFilters = () => {
        applyInitialFilters();
        if (_isMounted) {
            setIsLoaded(true);
        }
    }

    const getTitle = () => {
        if(!filterService) return '';
        const { search, collections } = filterService;
        if (search !== '' || collections !== '') {
            return "Búsqueda: " + search;
        } else if(filterByBrand){
            return filters.brands.map(brand => brand.Name).join(', ');
        } else {
            if(typeof category !== 'string'){
                return category ? category.name : "";
            }else{
                return category.replace(/-/g, ' ');
            }
        }
    }

    const getCrumbs = () => {
        if(!filterService) return [];
        if (filterService.search !== '' && filterService.collections !== '') {
            const { pathname, search } = window.location;
            return [
                {
                    title: 'Resultados de Búsqueda',
                    url: pathname + search
                }
            ]
        }

        if(filterByBrand){
            const { pathname, search } = window.location;
            return [
                {
                    title: filters.brands.map(brand => brand.Name).join(', '),
                    url: pathname + search
                }
            ]
        }

        let urlCategoryEmpty = '';
        if (categories.length === 0) return [];
        return categories.map((category) => {
            if(typeof category !== 'string'){
                return {
                    title: category.name,
                    url: category.url
                }
            } else {

                urlCategoryEmpty = urlCategoryEmpty + '/' + category;
                let categoryUrl = category.replace(/-/g,' ');
                categoryUrl = categoryUrl.charAt(0).toUpperCase() + categoryUrl.slice(1);

                return {
                    title: categoryUrl,
                    url: urlCategoryEmpty
                }
            }
        });
    }

    const changeQuantity = (value) => {
        setQuantity(value);
    }

    const title = getTitle();
    const title_path = props.location.pathname.replace('/', '').replace('_', ' ');
    const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
    const crumbs = getCrumbs();

    const sideFilters = filterByBrand && filters ? {...filters, brands: []} :  filters;

    return (
        <div className="catalog-page page">
            {isLoaded && <Metas>
                <title>{title_crumbs.replace(/-/g, " ")} | Jumbo.cl</title>
                <meta name="description" content={"Encuentra la mejor variedad de productos de " + title_crumbs.replace(/-/g, " ") + " en jumbo.cl"} />
                <meta name="Abstract" content={"Encuentra la mejor variedad de productos de " + title_crumbs.replace(/-/g, " ") + " en jumbo.cl"} />
            </Metas>}
            <div className="container">
                {!isLoaded && <div className="catalog-page-loader">
                    <Loader />
                </div>}
                {isLoaded && <div className="catalog-page-content">
                    <main className="shelf-main">
                        {isLoaded && <BreadCrumb crumbs={crumbs} />}
                        {isLoaded && <ShelfHeader title={title || title_crumbs} quantity={quantity} filter={filterService} filters={sideFilters} specifications={specifications}/>}
                        {isLoaded && <BannerShelf location={props.location}/>}
                        {isLoaded && <Shelf title={title || title_crumbs} filter={filterService} categories={categories} changeQuantity={changeQuantity} />}
                    </main>
                </div>}
            </div>
        </div>
    )

}

Catalog.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object
};

export default Catalog;
